import React from 'react';
import { FulfillmentButtonState } from '../../../types';

type Props = {
  buttonState: FulfillmentButtonState;
  classes?: string;
};

const FulfillmentButtonLowStockMessage = ({ buttonState, classes = '' }: Props) => {
  const { selectedMessaging } = buttonState;
  if (selectedMessaging.showLowStock && selectedMessaging.quantity) {
    return (
      <p
        className={`${classes} FulfillmentButtonLowStockMessage hmf-m-0 hmf-body-m label-sale`}>{`Only ${selectedMessaging.quantity} left!`}</p>
    );
  }

  return null;
};

export default FulfillmentButtonLowStockMessage;
